import { RouteObject } from 'react-router-dom';
import { TemporaryPaths } from 'routes';
import Temporary from '../screens/temporary';
import TemporaryScreensWrapper from '../components/temporary-screens-wrapper';

const temporaryRouter: RouteObject[] = [
  {
    path: '/',
    element: <TemporaryScreensWrapper />,
    children: [
      {
        path: TemporaryPaths.main,
        element: <Temporary />,
      },
      {
        path: TemporaryPaths.temporaryList,
        element: <div>temporary-list</div>,
      },
    ],
  },
];

export default temporaryRouter;
